export const BoilerplateConfig = {
  layout: {
    // Set to true to enable the left sidebar menu, false to disable it
    enableLeftMenu: false,

    // Other layout options can be added here in the future
    // enableBreadcrumbs: true,
    // enablePageTitle: true,
  },

  // Authentication Configuration
  auth: {
    // Set to true to require authentication for protected routes
    requireAuth: true,

    // Set to true to remember user login state
    enableRememberMe: true,
  },

  // Application Information
  app: {
    name: 'React Starter Boilerplate',
    version: '1.0.0',
  },
};

// Helper function to check if left menu is enabled
export const isLeftMenuEnabled = () => BoilerplateConfig.layout.enableLeftMenu;
